/**
 * Nova vacina no catálogo (#530).
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@mui/material';
import { PageShell } from '../../components';
import { vaccineTypeService } from '../../services/vaccineTypeService';
import { getApiErrorMessage } from '../../types/common';
import type { VaccineTypePayload } from '../../types/vaccination';
import { VaccineTypeForm } from './components/VaccineTypeForm';

export const VaccineTypeCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const handleSubmit = async (data: VaccineTypePayload) => {
    try {
      setIsSubmitting(true);
      setErro(null);
      await vaccineTypeService.create(data);
      navigate('/vaccine-types');
    } catch (err: unknown) {
      setErro(getApiErrorMessage(err, 'Erro ao criar a vacina'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Vacinas', path: '/vaccine-types' },
        { label: 'Nova vacina' },
      ]}
      title="Nova vacina"
      subtitle="Nome, meses das doses do esquema e intervalo de reforço"
    >
      <Card>
        <CardContent>
          <VaccineTypeForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/vaccine-types')}
            isSubmitting={isSubmitting}
            erro={erro}
          />
        </CardContent>
      </Card>
    </PageShell>
  );
};

export default VaccineTypeCreatePage;
